/* ==========================================================================
   THE FRAGRANCE WORLD
   Homepage behavior, used by layout/fw.liquid.

   The markup is rendered by the theme from live catalog data. This file only
   adds motion and the header's overlays, and every part checks that its section
   is on the page, so removing a section in the theme editor cannot break the rest.
   ========================================================================== */
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');
  const DESKTOP = () => innerWidth > 900;

  /* ========================================================= SCROLL ENGINE
     One rAF loop. Each registered section is measured once, then scrollY maps
     to a 0..1 progress that is written to a CSS custom property. CSS does the
     arithmetic from there, so a frame is a handful of style writes, not one
     per animated element.
     ------------------------------------------------------------------------ */
  const Engine = (() => {
    const items = [], layout = [];
    let queued = false, lastY = -1;

    /* mode: 'pin'     0 when the section top hits the viewport top, 1 when its
                       bottom hits the viewport bottom. The sticky travel range.
             'through' 0 as the section enters from the bottom, 1 as it clears
                       the top. Symmetrical, for parallax on mid-page sections.
             'leave'   0 at rest, 1 once the section has scrolled fully out.
                       For anything already on screen at load, the hero above all.
             'page'    like 'leave', but counted from the top of the page, so it
                       moves on the first pixel of scroll rather than once the
                       section's top edge reaches the top of the viewport.
             'enter'   0 when the top reaches the viewport bottom, 1 a bit later. */
    const add = (el, mode, apply, span) => {
      if (el) items.push({ el, mode, apply, span: span || .75, p: -1 });
    };

    /* Sections that set their own height (the pinned ones) run first, so the
       offsets below are read after the page has settled at its final size. */
    const onLayout = fn => { layout.push(fn); fn(); };

    function measure() {
      const vh = innerHeight;
      for (const f of layout) f();
      const y = scrollY;
      for (const it of items) {
        const r = it.el.getBoundingClientRect();
        const top = r.top + y, h = r.height;
        if (it.mode === 'pin')          { it.a = top;      it.b = top + h - vh; }
        else if (it.mode === 'through') { it.a = top - vh; it.b = top + h; }
        else if (it.mode === 'leave')   { it.a = top;      it.b = top + h; }
        else if (it.mode === 'page')    { it.a = 0;        it.b = top + h; }
        else                            { it.a = top - vh; it.b = top - vh + vh * it.span; }
        if (it.b <= it.a) it.b = it.a + 1;
      }
      lastY = -1;
      frame();
    }

    function frame() {
      queued = false;
      const y = scrollY;
      if (y === lastY) return;
      lastY = y;
      for (const it of items) {
        const p = Math.min(1, Math.max(0, (y - it.a) / (it.b - it.a)));
        if (p !== it.p) { it.p = p; it.apply(p, it); }
      }
    }

    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(frame); } },
      { passive: true });

    let rt;
    const schedule = () => { clearTimeout(rt); rt = setTimeout(measure, 120); };

    addEventListener('resize', schedule);
    addEventListener('orientationchange', () => setTimeout(measure, 240));

    /* A resize event is not guaranteed for every viewport change: mobile browser
       chrome collapsing and devtools opening both move the box silently. Watch the
       root element instead, and compare against the last known viewport so the
       heights set below cannot feed back and retrigger us. */
    if (window.ResizeObserver) {
      let w = innerWidth, h = innerHeight;
      new ResizeObserver(() => {
        if (innerWidth === w && innerHeight === h) return;
        w = innerWidth; h = innerHeight;
        schedule();
      }).observe(document.documentElement);
    }

    return { add, measure, onLayout, schedule };
  })();

  const setP = el => p => el.style.setProperty('--p', p.toFixed(4));

  /* ------------------------------------------------- header state on scroll */
  const hdr = $('#hdr');
  if (hdr) {
    const stick = () => hdr.classList.toggle('stuck', scrollY > 30);
    addEventListener('scroll', stick, { passive: true });
    stick();
  }

  /* ------------------------------------------------------ entrance observer */
  const io = new IntersectionObserver(es => {
    for (const e of es) if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
  $$('.rise,.mask,[data-stagger]').forEach(n => io.observe(n));

  /* ---------------------------------------------------------- hero, scrubbed
     The stage drifts up and the copy lifts away as the section leaves. Small
     numbers on purpose: felt, not noticed. The backdrop needs nothing here: it
     is fixed to the screen (fw.css) and the page slides over it.              */
  {
    const hero = $('#hero');
    const shelf = $('#heroshelf');
    const copy = $('#herocopy');
    if (hero && shelf && copy) {
      const packs = [...shelf.children];

      /* two frames so the initial styles are committed and the entrance animates
         rather than jumping straight to the settled state */
      requestAnimationFrame(() => requestAnimationFrame(() => shelf.classList.add('in')));

      /* the outer packs drift faster than the middle, so the row fans open as it
         leaves rather than sliding away as one solid block */
      const RATE = [1.5, .95, .5, 1, 1.55];
      Engine.add(hero, 'leave', p => {
        if (REDUCED.matches) return;
        packs.forEach((el, i) => el.style.setProperty('--y', (-p * 72 * (RATE[i] ?? 1)).toFixed(1)));
        const f = Math.max(0, p - .25) / .75;        /* copy holds, then lifts away */
        copy.style.transform = `translate3d(0,${(-f * 44).toFixed(1)}px,0)`;
        copy.style.opacity = (1 - f * .95).toFixed(3);
      });
    }
  }

  /* --------------------------------------------------- marquee of the houses
     Drifts on its own, and scroll nudges it along. Wraps by modulo of one
     copy's width, so the seam never shows.                                    */
  {
    const rail = $('#houserail');
    if (rail) {
      let x = 0, span = 0, prevY = scrollY, boost = 0, running = false;
      const remeasure = () => { span = rail.scrollWidth / 2 || 1; };
      addEventListener('resize', remeasure);

      function loop() {
        if (!running) return;
        const dy = scrollY - prevY; prevY = scrollY;
        boost = boost * .88 + dy * .12;
        x = (x + .35 + boost) % span;
        if (x < 0) x += span;
        rail.style.transform = `translate3d(${-x.toFixed(2)}px,0,0)`;
        requestAnimationFrame(loop);
      }

      /* Only spins while it is on screen. Nothing runs off screen. */
      new IntersectionObserver(es => {
        const on = es[0].isIntersecting && !REDUCED.matches;
        if (on === running) return;
        running = on;
        if (on) { remeasure(); prevY = scrollY; requestAnimationFrame(loop); }
      }, { rootMargin: '200px' }).observe(rail);
    }
  }

  /* ----------------------------------------------- moment 1: the credo words */
  {
    const credo = $('#credo');
    if (credo) {
      /* 3 screens tall, 1 of them sticky. That leaves 2 screens of scroll to
         light 30 words in, which lands at about a comfortable reading pace. */
      Engine.onLayout(() => {
        credo.style.height = (DESKTOP() && !REDUCED.matches) ? '300vh' : '';
      });
      Engine.add(credo, 'pin', setP(credo));
    }
  }

  /* ------------------------------------------------- house tiles arrive in a
     wave, each one a little behind the last, driven by section progress.      */
  {
    const tiles = $$('#byhouse .t');
    if (tiles.length) {
      Engine.add($('#byhouse'), 'enter', p => {
        tiles.forEach((t, i) => {
          const local = Math.min(1, Math.max(0, (p * 1.45) - i * .07));
          t.style.setProperty('--tp', local.toFixed(3));
        });
      }, .62);
    }
  }

  /* ----------------------- type panels: bottles drift inside their windows */
  $$('#bytype .p').forEach(p => Engine.add(p, 'through', v => p.style.setProperty('--tp', v.toFixed(3))));

  /* ------------------------------------------------------------ price rail
     A native sideways scroller, so the page scrolls straight past it. The
     arrows page through it a screenful of cards at a time, and the hairline
     under the heading shows which stretch is in view.                         */
  {
    const sec = $('#gap');
    const rail = $('#gaprail');
    const prev = $('#gap .prev');
    const next = $('#gap .next');
    if (sec && rail && prev && next) {
      const cards = [...rail.children];
      let queued = false;

      /* aria-disabled rather than disabled, so a button that runs out of cards
         keeps keyboard focus instead of dropping it back to the page */
      function update() {
        queued = false;
        const max = rail.scrollWidth - rail.clientWidth;
        const x = rail.scrollLeft;
        sec.classList.toggle('fits', max < 2);
        prev.setAttribute('aria-disabled', String(x < 2));
        next.setAttribute('aria-disabled', String(x > max - 2));
        sec.style.setProperty('--v', (rail.clientWidth / rail.scrollWidth).toFixed(4));
        sec.style.setProperty('--p', max < 2 ? 0 : (x / max).toFixed(4));
      }

      /* Counted in whole cards from the first one fully in view. Forward lands
         the card just past the screen on the gutter, back lands the card one
         screen earlier, which is where scroll snapping would put either one,
         so nothing is skipped and nothing jumps when the scroll settles. */
      function page(dir) {
        if (cards.length < 2) return;
        const pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
        const step = cards[1].offsetLeft - cards[0].offsetLeft;
        const gap = step - cards[0].offsetWidth;
        const perScreen = Math.max(1, Math.floor((rail.clientWidth - 2 * pad + gap) / step));
        const x = rail.scrollLeft;
        let first = cards.findIndex(c => c.offsetLeft - pad >= x - 2);
        if (first < 0) first = cards.length - 1;
        const to = cards[Math.min(cards.length - 1, Math.max(0, first + dir * perScreen))];
        const max = rail.scrollWidth - rail.clientWidth;
        rail.scrollTo({
          left: Math.min(max, Math.max(0, to.offsetLeft - pad)),
          behavior: REDUCED.matches ? 'auto' : 'smooth',
        });
      }

      prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') !== 'true') page(-1); });
      next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') page(1); });
      rail.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } },
        { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
      else addEventListener('resize', update);
      update();
    }
  }

  /* -------------------------------------------- moment 2: the sourcing stack */
  {
    const sec = $('#source');
    const steps = $$('#source .step');
    if (sec && steps.length) {
      const left = $('.left', sec);
      const num = $('#srcnum');
      let active = -1;
      Engine.add(sec, 'pin', p => {
        left.style.setProperty('--p', p.toFixed(4));
        if (!DESKTOP()) return;
        const i = Math.min(steps.length - 1, Math.floor(p * steps.length + .18));
        if (i === active) return;
        active = i;
        if (num) num.textContent = String(i + 1).padStart(2, '0');
        steps.forEach((s, j) => s.classList.toggle('dim', j !== i));
      });
    }
  }

  /* ------------------------------------------- guarantee numbers count up */
  {
    const box = $('#promisenums');
    if (box) {
      const nums = $$('b', box);
      const set = p => {
        const e = 1 - Math.pow(1 - p, 3);            /* ease out so it settles */
        nums.forEach(n => {
          if (n.dataset.literal) { n.textContent = p > .55 ? n.dataset.literal : '0'; return; }
          n.textContent = Math.round(+n.dataset.count * e) + (n.dataset.suffix || '');
        });
      };
      if (!REDUCED.matches) Engine.add(box, 'enter', set, .55);
    }
  }

  /* ============================================================== CHROME UI
     The search icon and the menu icon are real links, to /search and to the
     #drawer anchor, so both work before this runs or if it never does. Here
     they open in place instead. A closed overlay is inert, so the keyboard
     cannot wander into something that is not on screen.                       */
  const search = $('#search');
  const drawer = $('#drawer');
  const lock = on => { document.body.style.overflow = on ? 'hidden' : ''; };
  let returnFocus = null;

  const setInert = (el, on) => { if (el) el.inert = on; };
  setInert(search, true);
  setInert(drawer, true);

  function openSearch(trigger) {
    if (!search) return;
    returnFocus = trigger || document.activeElement;
    setInert(search, false);
    search.classList.add('open'); lock(true);
    setTimeout(() => $('input[type="search"]', search)?.focus(), 120);
  }
  function closeSearch() {
    if (!search || !search.classList.contains('open')) return;
    search.classList.remove('open'); lock(false);
    setInert(search, true);
    returnFocus?.focus?.();
  }
  function openDrawer(trigger) {
    if (!drawer) return;
    returnFocus = trigger || document.activeElement;
    setInert(drawer, false);
    drawer.classList.add('open'); lock(true);
    $('#burger')?.setAttribute('aria-expanded', 'true');
    setTimeout(() => $('a:not(.x)', drawer)?.focus(), 120);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open'); lock(false);
    setInert(drawer, true);
    $('#burger')?.setAttribute('aria-expanded', 'false');
    if (location.hash === '#drawer') history.replaceState(null, '', location.pathname + location.search);
    returnFocus?.focus?.();
  }

  $('#opensearch')?.addEventListener('click', e => { if (!search) return; e.preventDefault(); openSearch(e.currentTarget); });
  $('[data-close-search]')?.addEventListener('click', closeSearch);
  search?.addEventListener('click', e => { if (e.target === search) closeSearch(); });

  $('#burger')?.addEventListener('click', e => { if (!drawer) return; e.preventDefault(); openDrawer(e.currentTarget); });
  $('[data-close-drawer]')?.addEventListener('click', e => { e.preventDefault(); closeDrawer(); });
  $$('a:not(.x)', drawer || document.createElement('div')).forEach(a => a.addEventListener('click', () => lock(false)));
  if (location.hash === '#drawer') openDrawer();

  /* dropdown panels: hover and focus open them in CSS, a click or tap toggles */
  const panels = $$('#hdr .has-panel');
  const closePanels = except => panels.forEach(p => {
    if (p === except) return;
    p.classList.remove('open');
    $('button', p)?.setAttribute('aria-expanded', 'false');
  });
  panels.forEach(p => {
    const btn = $('button', p);
    btn?.addEventListener('click', () => {
      const open = !p.classList.contains('open');
      closePanels(p);
      p.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', e => { if (!e.target.closest('#hdr .has-panel')) closePanels(); });

  addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closePanels(); closeSearch(); closeDrawer();
  });

  /* smooth in-page jumps for the anchor links, the header excepted */
  $$('main a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    const id = a.getAttribute('href');
    if (id.length < 2) return;
    const t = $(id);
    if (!t) return;
    e.preventDefault();
    scrollTo({ top: t.getBoundingClientRect().top + scrollY, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }));

  /* ================================================================= START */
  Engine.measure();
  addEventListener('load', () => Engine.measure());
  /* product photography arrives late and changes section heights */
  $$('img').forEach(i => {
    if (!i.complete) i.addEventListener('load', Engine.schedule, { once: true });
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => Engine.measure());
})();
